/* Cortisol Control sleep advertorial — behaviour only.
   Everything here is progressive enhancement: with JS off the page is fully
   readable, all reviews are visible, all FAQ answers are reachable, and the
   offer CTA already adds the pre-selected 1-bottle subscription to the cart. */
(function () {
  var root = document.getElementById('csa-root');
  if (root) root.classList.remove('no-js');
})();

/* ---- sticky Add-to-Cart bar ----
   The Vercel page carried a sticky top nav; on the theme the store header
   already owns the top of the viewport, so the persistent CTA moved to a
   bottom bar. It appears once the buy box has scrolled past. Its price and
   cart link are kept in sync by the offer block below. */
(function () {
  var bar = document.getElementById('csa-sticky');
  var buy = document.getElementById('buy');
  if (!bar || !buy) return;
  var shown = null;
  function tick() {
    var r = buy.getBoundingClientRect();
    /* after the hero has gone, but never while the real buy box is on screen —
       a second Add to Cart floating over the actual one just reads as clutter */
    var buyOnScreen = r.top < window.innerHeight && r.bottom > 0;
    var show = window.scrollY > 420 && !buyOnScreen;
    if (show === shown) return;
    shown = show;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('csa-has-sticky', show);
  }
  addEventListener('scroll', tick, { passive: true });
  addEventListener('resize', tick, { passive: true });
  tick();
})();

/* ---- scroll reveal ----
   Sweep-based on purpose. An IntersectionObserver alone left whole sections at
   opacity 0 in a full-page screenshot (the ingredient cards, the supplement
   panel and the closing CTA all captured blank), and content that cannot be
   captured cannot be verified. This reveals anything within a generous band of
   the viewport on every scroll, and a short polling window covers programmatic
   scrolls and instant jumps. Nothing is ever left invisible. */
(function () {
  var els = [].slice.call(document.querySelectorAll('.reveal'));
  var BAND = 700;
  function sweep() {
    var h = window.innerHeight;
    for (var i = els.length - 1; i >= 0; i--) {
      var e = els[i];
      if (e.getBoundingClientRect().top < h + BAND) {
        e.classList.add('in');
        els.splice(i, 1);
      }
    }
    return els.length === 0;
  }
  function atBottom() {
    return window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 240;
  }
  function all() { els.forEach(function (e) { e.classList.add('in'); }); els.length = 0; }
  function step() {
    if (atBottom()) { all(); return true; }
    return sweep();
  }
  step();
  addEventListener('scroll', step, { passive: true });
  addEventListener('resize', step, { passive: true });
  var poll = setInterval(function () { if (step()) clearInterval(poll); }, 150);
  // Hard backstop. Deliberately short: a full-page screenshot must be able to
  // capture every section, and anything a capture can't see can't be verified.
  // The reveal is a first-1.5s fade-in, not a permanent gate on content.
  setTimeout(function () { clearInterval(poll); all(); }, 1500);
})();

/* ---- offer: the live PDP's offer, tier by tier and mode by mode ----
   Matches us.martinclinic.com/products/cortisol-control-formula exactly:
     one-time   1 x $39.00 | 3 x $97.11 (17% off) | 6 x $187.20 (20% off)
     subscribe  20% off at 30 days, 25% at 90, 30% at 180 (Loop plans below)
   Prices here are DISPLAY. What actually bills:
     one-time  = the bundle variant price on `cortisol-control-formula`
                 (Simple Bundles splits the 3/6-pack into single bottles at checkout)
     subscribe = N x the component bottle (`cortisol-control-single`, variant
                 46222899118328) with the Loop selling plan attached, so the
                 Loop % is what discounts it — same as the PDP's own buy box.
   Both paths were checkout-verified against a real US cart, Jul 28 2026. */
(function () {
  var tiers = [].slice.call(document.querySelectorAll('.qty-card'));
  var modes = [].slice.call(document.querySelectorAll('.mode'));
  var cta = document.getElementById('buycta');
  if (!tiers.length || !cta) return;

  var V_COMPONENT = 46222899118328;         /* single bottle, the subscribe unit */
  var LIST_PER_BOTTLE = 3900;               /* 1-bottle one-time IS list price */
  var CAPS_PER_BOTTLE = 60;
  var MAX_QTY = 10;
  /* relative, not absolute: on the theme this must resolve against whatever
     host is serving the page (theme preview, theme dev, us.martinclinic.com) */
  var CART = '/cart/add?id=';

  var el = {
    percap: document.getElementById('percap'),
    ctatotal: document.getElementById('ctatotal'),
    subpct: document.getElementById('subpct'),
    subnow: document.getElementById('subnow'),
    substrike: document.getElementById('substrike'),
    subper: document.getElementById('subper'),
    otpnow: document.getElementById('otpnow'),
    cadlabel: document.getElementById('cadlabel'),
    qtyval: document.getElementById('qtyval'),
    qtyminus: document.getElementById('qtyminus'),
    qtyplus: document.getElementById('qtyplus'),
    stickycta: document.getElementById('csa-sticky-cta'),
    stickytotal: document.getElementById('csa-sticky-total'),
    stickysub: document.getElementById('csa-sticky-sub')
  };

  var state = { tier: tiers[0], mode: 'sub', qty: 1 };
  tiers.forEach(function (t) { if (t.classList.contains('on')) state.tier = t; });

  /* $39 reads as "$39" in the strike-through and "$39.00" as a live price, same
     as the PDP's fmtMoney / fmtMoneyZ pair. */
  function money(cents) {
    var d = cents / 100;
    return '$' + (Math.round(d * 100) % 100 === 0 ? String(Math.round(d)) : d.toFixed(2));
  }
  function moneyZ(cents) { return '$' + (cents / 100).toFixed(2); }
  function set(node, text) { if (node) node.textContent = text; }

  function render() {
    var t = state.tier;
    var bottles = +t.dataset.bottles;
    var otp = +t.dataset.otp;
    var sub = +t.dataset.sub;
    var days = t.dataset.days;
    var caps = bottles * CAPS_PER_BOTTLE;
    var list = LIST_PER_BOTTLE * bottles;
    var subbing = state.mode === 'sub';
    var unit = subbing ? sub : otp;

    set(el.percap, bottles + ' bottle' + (bottles > 1 ? 's' : '') + ' · ' + caps +
      ' capsules · $' + (unit / caps / 100).toFixed(2) + ' per capsule');

    set(el.subnow, moneyZ(sub));
    set(el.substrike, money(list));
    set(el.subpct, Math.round((list - sub) / list * 100) + '% OFF');
    set(el.subper, money(Math.round(sub / bottles)));
    set(el.otpnow, moneyZ(otp));
    set(el.cadlabel, 'Delivered every ' + days + ' days · ' + bottles +
      ' bottle' + (bottles > 1 ? 's' : ''));

    tiers.forEach(function (o) {
      var on = o === t;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    set(el.qtyval, state.qty);
    if (el.qtyminus) el.qtyminus.disabled = state.qty <= 1;
    if (el.qtyplus) el.qtyplus.disabled = state.qty >= MAX_QTY;
    set(el.ctatotal, moneyZ(unit * state.qty));

    /* Subscribe adds bottles x the component with the Loop plan; one-time adds
       the bundle variant. Same two paths the PDP buy box posts. */
    cta.href = subbing
      ? CART + V_COMPONENT + '&quantity=' + (bottles * state.qty) + '&selling_plan=' + t.dataset.plan
      : CART + t.dataset.variant + '&quantity=' + state.qty;

    /* the sticky bar sells the same thing the buy box is showing */
    if (el.stickycta) el.stickycta.href = cta.href;
    set(el.stickytotal, moneyZ(unit * state.qty));
    set(el.stickysub, (subbing ? 'Subscribe & Save' : 'One-time') + ' · ' + bottles +
      ' bottle' + (bottles > 1 ? 's' : '') + ' · 60-day guarantee');
  }

  tiers.forEach(function (t) {
    t.addEventListener('click', function () { state.tier = t; render(); });
  });

  function pickMode(m) {
    state.mode = m.dataset.mode;
    modes.forEach(function (o) {
      var on = o === m;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    render();
  }
  modes.forEach(function (m) {
    m.addEventListener('click', function () { pickMode(m); });
    m.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickMode(m); }
    });
  });

  function bump(by) {
    var next = state.qty + by;
    if (next < 1 || next > MAX_QTY) return;
    state.qty = next;
    render();
  }
  if (el.qtyminus) el.qtyminus.addEventListener('click', function () { bump(-1); });
  if (el.qtyplus) el.qtyplus.addEventListener('click', function () { bump(1); });

  render();
})();

/* ---- reviews: collapse to three, then let the reader open the rest.
   The markup ships with all six visible and the button hidden, so a JS-off
   reader gets every review instead of a dead "read more". ---- */
(function () {
  var btn = document.getElementById('morebtn');
  var note = document.getElementById('morenote');
  if (!btn) return;
  var extra = [].slice.call(document.querySelectorAll('#rvlist [data-more]'));
  extra.forEach(function (c) { c.hidden = true; });
  btn.hidden = false;
  btn.addEventListener('click', function () {
    [].slice.call(document.querySelectorAll('#rvlist [data-more]')).forEach(function (c) {
      c.hidden = false;
      c.classList.add('in');
    });
    btn.hidden = true;
    if (note) note.hidden = false;
  });
})();

/* ---- FAQ category filter ---- */
(function () {
  var tabs = document.getElementById('tabs');
  if (!tabs) return;
  var items = [].slice.call(document.querySelectorAll('.faq details'));
  tabs.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    [].slice.call(tabs.querySelectorAll('button')).forEach(function (o) { o.classList.remove('on'); });
    b.classList.add('on');
    var cat = b.dataset.cat;
    items.forEach(function (d) {
      d.hidden = !(cat === 'all' || d.dataset.cat === cat);
    });
  });
})();
